import { c as _c } from "react/compiler-runtime";
import { digitalProductDependencies } from 'modules/digital-product/constants/digital-product-dependencies';
import { FUNNELS_API } from 'modules/funnels/api/funnels-api';
import { OfferFormViewInterface } from 'modules/funnels/funnel/components/step-configuration-tab/offer-form-configuration-tab/types/offer-form-interface';
import { FunnelStepId } from 'modules/funnels/funnel/types/funnel-step-interface';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import { useControlledSwr } from 'shared/hooks/use-controlled-swr';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { useMutationUpdate } from 'shared/hooks/use-mutation-update';
import useUser from 'shared/hooks/use-user';
const getOfferSettingsApiKey = (id: FunnelStepId) => `${FUNNELS_API}/steps/${id}/offer-form`;
export function useOfferFormSettings(id) {
  const $ = _c(7);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== id || $[2] !== user) {
    t1 = () => user && [getOfferSettingsApiKey(id), ...digitalProductDependencies, RequestModuleEnum.PhysicalProducts];
    $[1] = id;
    $[2] = user;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    data: offerFormSettings,
    mutate: mutateOfferFormSettings
  } = useControlledSwr(t1, fetcher);
  let t2;
  if ($[4] !== mutateOfferFormSettings || $[5] !== offerFormSettings) {
    t2 = {
      offerFormSettings,
      mutateOfferFormSettings
    };
    $[4] = mutateOfferFormSettings;
    $[5] = offerFormSettings;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}
export const useOfferFormSettingsMutation = () => {
  const mutate = useMutationUpdate();
  const clearCurrencyRelatedFields = async (funnelStepIds?: number[]) => {
    if (!funnelStepIds) return;
    for await (const id of funnelStepIds) {
      await mutate<OfferFormViewInterface>(getOfferSettingsApiKey(id), data => data && {
        ...data,
        offer: {
          ...data.offer,
          bumps: [],
          coupons: [],
          product: null,
          digitalProduct: null
        }
      });
    }
  };
  return {
    clearCurrencyRelatedFields
  };
};